export class PricingTier {
  private constructor(public readonly name: string) {}

  static make(inputPlan: string): PricingTier {
    return new PricingTier(inputPlan);
  }
}
